module.exports = __webpack_public_path__ + "img/insitu_logo.fe2b24d5.png";